import * as wjrGrid from "@grapecity/wijmo.react.grid"

/**
 * 列ヘッダーの文字表示のみ消すcellTemplate
 * @param props
 * @returns
 */
const EmptyTextHeader = (
  props: React.ComponentProps<typeof wjrGrid.FlexGridCellTemplate>
) => (
  <wjrGrid.FlexGridCellTemplate
    cellType={wjrGrid.CellTemplateType.ColumnHeader}
    template={() => {
      return <></>
    }}
    {...props}></wjrGrid.FlexGridCellTemplate>
)
export default EmptyTextHeader
